<template>
  <div class="layout">
    <slot></slot>
  </div>
</template>

<script>
import MallToolbar from "@/components/mall-toolbar";

export default {
  name: 'Layout',
  mixins: [MallToolbar],
  data() {
    return {
      loadScriptDone: false
    }
  },
  methods: {
    loadScript(src, cb) {
      if (!src) return;
      try {
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = src;
        s.async = true;
        s.onload = function () {
          typeof cb === "function" && cb();
        };
        var t = document.getElementsByTagName("script")[0];
        t.parentNode.insertBefore(s, t);
      } catch (error) {
        console.error("load script error: ", error);
        typeof cb === "function" && cb();
      }
    },
  },
  mounted() {
    !this.loadScriptDone && this.loadScript('https://g.csdnimg.cn/common/csdn-footer/csdn-footer.js',() => {
      this.loadScriptDone = true;
    })
  }
}
</script>

<style lang="less" scoped>
.layout {
  position: relative;
  width: 100%;
  min-width: 1400px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f5f6f7;

  header {
    position: sticky;
    top: 0;
    width: 100%;
    height: 48px;
  }

  .range {
    padding-top: 12px;
    display: flex;

    .tabs {
      width: 192px;
      display: flex;
      height: auto;
      flex-direction: column;
      border-radius: 2px;
    }

    .content {
      margin: 0 10px;
      width: 814px;
      background: #fff;
      translate: all 0.2s ease;
    }

    .right {
      width: 338px;
    }
  }
}
</style>